import { combineReducers } from 'redux'
import auth from './auth'
import navbar from './navbar'
import layout from './layout'
import email from '@src/views/email/store/reducer'

const rootReducer = combineReducers({
  auth,
  navbar,
  layout,
  email,
  // profile,
  document
})

export default rootReducer
